<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="상품 이용 신청서 조회"
      desc="상품 이용 신청서 현황을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="2200"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <!-- 문의 타입 -->
      <div slot="inquiry_type" slot-scope="props">
        <span v-if="props.item.products.length > 0">선주문 테마 상품 신청</span>
        <span v-else>테마 상품 신청</span>
      </div>

      <!-- 상품 이름 -->
      <div slot="product_name" slot-scope="props">
        <span v-if="props.item.product_name">{{ props.item.product_name }}</span>
        <span v-else>-</span>
      </div>

      <!-- 테마 이름 -->
      <div slot="theme_name" slot-scope="props">
        <span v-if="props.item.theme_name">{{ props.item.theme_name }}</span>
        <span v-else>-</span>
      </div>

      <!-- 서비스 아이디 -->
      <div slot="service_id" slot-scope="props">
        <span v-if="props.item.service_id">{{ props.item.service_id }}</span>
        <span v-else>-</span>
      </div>
      <!-- 서비스 이름 -->
      <div slot="service_name" slot-scope="props">
        <span v-if="props.item.service_name">{{ props.item.service_name }}</span>
        <span v-else>-</span>
      </div>

      <div slot="price" slot-scope="props">
        {{ props.item.price | currency }}
      </div>

      <div slot="status" slot-scope="props">
        <span>{{ convertStatus(props.item.status, props.item.service_status) }}</span>
      </div>

      <div slot="status_action" slot-scope="props">
        <button class="button btn-reg-service" @click="regService(props.item)"
                v-if="props.item.status===2 && props.item.service_status===1">서비스 등록</button>
        <span v-else-if="props.item.status===2 && props.item.service_status===2">-</span>
        <button class="button btn-confirm" @click="changeStatus(props.item, 1)" v-else-if="props.item.status===0">신청확인완료</button>
        <button class="button btn-success" @click="changeStatus(props.item, 2)" v-else-if="props.item.status===1">상담완료</button>
        <button class="button btn-input" @click="clickModal(props.item.id)" v-else-if="props.item.status===2">상담후 결과입력</button>
      </div>

      <div slot="service_status" slot-scope="props">
        <span v-if="props.item.service_status===0">대기상태</span>
        <span v-else-if="props.item.service_status===1">서비스 등록</span>
        <span v-else-if="props.item.service_status===2">서비스 등록안함</span>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button" @click="$router.push(`request/detail?id=${props.item.id}`)">상세</button>
      </div>
    </admin-table>

    <modal name="svModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <lp-radio :val.sync="service_status"
                  value_name="value"
                  label_name="label"
                  :data="[{label:'서비스 등록함',value:1},{label:'서비스 등록안함',value:2}]"></lp-radio>
        <div class="btn-group-justify-end">
          <button @click="saveServiceStatus" class="button is-primary">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpSortDropDown from '../../../module/common/LpSortDropDown'
  import LpInputText from '../../../module/common/LpInputText'
  import LpRadio from '../../../module/common/LpRadio'
  import { SweetModal } from 'sweet-modal-vue'
  import LpModal from '../../../module/common/LpModal.vue'
  import AdminFilter from "../../../module/admin/AdminFilter";
  import AdminTable from "../../../module/admin/AdminTable";
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'ThemeRequest',
    layout:'Main',
    mixins: [
      ListMixin
    ],
    props: ['page'],
    components: {
      AdminTable,
      AdminFilter,
      SweetModal, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
    },
    data () {
      return {
        id: 0,
        service_status: 1
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('theme_request', 'launchpack/theme/request');
      },
      getDataFromServer() {
        this.getData();
      },
      saveServiceStatus(){
        this.$axios.post(this.getUrl(`launchpack/theme/request/${this.id}/service`), {
          status: this.service_status
        }).then(res=>{
          if(res.status===200) {
            this.toast('저장되었습니다.');
            this.id = 0;
            this.service_status = 1;
            this.$modal.hide('svModal');
            this.initializing('theme_request', 'launchpack/theme/request');
          }
        })
      },
      clickModal(id) {
        this.id = id;
        this.$modal.show('svModal');
      },
      regService(item) {
        let query = '';
        if(item.user) query = `?theme_request_id=${item.id}`;
        this.$router.push(this.getPath(`launchpack/service/create${query}`));
      },
      // 요청할 상태값
      changeStatus(item, req_status){
        this.$axios.post(this.getUrl(`launchpack/theme/request/${item.id}/accept`), {
          status: req_status
        }).then(res=>{
          if(res.status===200) {
            item.status=req_status;
            this.toast('완료되었습니다.');
          }
        })
      },
      convertStatus(status, service_status){
        let value = '';
        if (status===0) value = '신청미확인';
        else if (status===1) value = '신청확인';
        else if (status===2) value = '상담완료';
        else if(status===2 && service_status===1) value = '서비스등록'
        else if(status===2 && service_status===2) value = '상담완료'
        return value;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .btn-reg-service
  .btn-confirm
  .btn-success
  .btn-input
    color white

  .btn-reg-service
    background-color #63c2de

  .btn-confirm
    background-color #ffc107

  .btn-success
    background-color #fd7014

  .btn-input
    background-color #4dbd74


</style>
